import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAllTax({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/tax/page`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

export function _addTax({ area, tax_type, rate, tax_desc },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/tax`,
    method: 'post',
    data: {
      area,
      tax_type,
      rate,
      tax_desc
    }
  });
}

export function _deleteTax(taxId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/tax/${taxId}`,
    method: 'delete',
  });
}

export function _updateTax(id, { area, tax_type, rate, tax_desc }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/tax/${id}`,
    method: 'patch',
    data: {
      area,
      tax_type,
      rate,
      tax_desc
    }
  });
}

export function _getTaxDetail(id) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/tax/${id}`,
    method: 'get',
  })
}

export default {};
